
        var result = require("!!../../../../node_modules/css-loader/index.js!./settings-eventaction-color.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/settings/settings-eventaction/settings-eventaction-color.component.css
// module id = 2421
// module chunks = 1